import { useParams } from "react-router-dom";

export function useEstablishment() {
  const { establishmentId }: { establishmentId: string } = useParams();
  return establishmentId;
}
